<template>
    <div>
        <Header title="资质模板" memo="管理资质证书模板信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    添加
                </a-button>
                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="模板名称" @pressEnter="execQuery">
                            <a-icon slot="prefix" type="safety-certificate" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-select
                            style="width: 200px;"
                            mode="default"
                            v-model="query.unit"
                            label-in-value
                            placeholder="选择归属机构"
                            :filter-option="false"
                            :not-found-content="unitLoading ? undefined : null"
                            @search="doLoadUnit"
                            @change="execQuery"
                        >
                            <a-spin v-if="unitLoading" slot="notFoundContent" size="small" />
                            <a-select-option v-for="d in units" :key="d.name">
                                {{ d.text }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column data-index="name" ellipsis width="200px">
                <span slot="title">模板名称</span>
                <template slot-scope="text, record">
                    {{ record.name }}
                </template>
            </a-table-column>
            <a-table-column data-index="info" ellipsis>
                <span slot="title">证书信息</span>
                <template slot-scope="text, record">
                    <a-tag color="#f50">
                        {{ record.type | fmtCertType }}
                    </a-tag>
                    <a-tag color="#108ee9">
                        {{ record.grade | fmtCertGrade }}
                    </a-tag>
                    <a-tag color="#2db7f5">
                        {{ record.level }}
                    </a-tag>
                </template>
            </a-table-column>
            <a-table-column data-index="days" ellipsis width="150px">
                <span slot="title">有效期</span>
                <template slot-scope="text, record">
                    {{ record.days | fmtDays }}
                </template>
            </a-table-column>
            <a-table-column data-index="munit" ellipsis width="150px">
                <span slot="title">发证单位</span>
                <template slot-scope="text, record">
                    {{ record.munit }}
                </template>
            </a-table-column>
            <a-table-column key="action" width="300px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="eye" @click="showView(record)">
                        详情
                    </a-button>
                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                        编辑
                    </a-button>
                    <a-popconfirm :title="'是否删除模板[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button type="link" icon="delete">
                            删除
                        </a-button>
                    </a-popconfirm>
                </template>
            </a-table-column>
        </a-table>
        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑模板" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>

        <ViewComp title="模板详情" :item="now" :show.sync="view" v-if="view"></ViewComp>
    </div>
</template>

<script>
import FormComp from './FormComp'
import ViewComp from './ViewComp'

export default {
    name: 'CertTmpl',
    components: {
        FormComp,
        ViewComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                name: '',
                unit: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            form: false,
            now: {},
            units: [],
            unitLoading: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云信网', '资质模板'])
        this.doLoad()
    },
    methods: {
        doLoadUnit(name) {
            this.unitLoading = true
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.unitLoading = false
                    this.units = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/crs/cert/tmpl/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/crs/cert/tmpl/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },
        showView(item) {
            this.now = item
            this.view = true
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的模板')
                return
            }
            this.$confirm({
                title: '是否删除以下模板？删除后无法恢复。',
                content: '模板：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
